export default "__VITE_ASSET__BGjuFv9f__"